import {
  hasMakeRequestBridge,
  ingestData,
  isMobile,
  makeRequest,
} from "../../../bridges/BridgeServices";
import { bridgePromiseWrapper } from "../../../bridges/BridgePromise/bridgePromise";
import { setOrdersLoading } from "../../../store/slices/recentActivity/recentActivity.setters";
import {
  API_ENUMS,
  API_METHODS,
} from "../../../bridges/bridgeConstants";
import { createApiData } from "../../service.helper";
import {
  AUTH_LEVEL,
  EVENTS,
} from "../../../utils/constants";
import { GET_ORDERS_URL } from "../recentActivity.url";
import { getAuthLevel } from "../../../store/slices/common/common.getters";

const fetchOrders = async (nextPageToken = null) => {
  try {
    if (isMobile() && !hasMakeRequestBridge()) return;

    const apiData = () => {
      let payload = { direction: "REVERSE", limit: 20 };
      payload = nextPageToken
        ? {
            ...payload,
            pointer: {
              cursor: nextPageToken,
            },
          }
        : payload;
      return createApiData(
        API_METHODS.POST,
        GET_ORDERS_URL,
        payload
      );
    };

    setOrdersLoading(true);
    const resp = await bridgePromiseWrapper(
      makeRequest(
        {
          ...apiData(),
        },
        API_ENUMS.GET_ORDERS,
        () => setOrdersLoading(false)
      )
    );
  } catch (err) {
    ingestData({
      name: EVENTS.FETCH_ORDERS_ERROR,
    });
  }
};

export default fetchOrders;
